import React, { useMemo } from "react"
import BasicProfile from "../components/profile/BasicProfile";
import SocialAccountCard from "../components/profile/SocialAccountCard";
import { useSelector } from "react-redux";
import { AppDispatch, RootState } from "../redux-stores/store";
import { useDispatch } from "react-redux";
import { toggleAddSocialAccountModal } from "../redux-stores/slices/layoutSlice";
import { platforms } from "../constants/constants";
import AccountDeletion from "../components/account/AccountDeletion";
import withSlideUpModal from "../utils/hoc/withSlideUpModalComponent";

const AccountDeletionModal = withSlideUpModal(AccountDeletion);

const Profile: React.FC = () => {
    const dispatch: AppDispatch = useDispatch();
    const socialAccounts = useSelector((state: RootState) => state.influencer.social_accounts);
    const maxSocialAccountsConfig = useSelector((state: RootState) => state.auth?.configurations?.max_social_accounts || {});
    const [isAccountDeletionModalActive, setAccountDeletionModalActive] = React.useState(false);
    const allPlatformsAdded = useMemo(() => {
        return Object.values(platforms).every(platform => {
            const maxForPlatform = maxSocialAccountsConfig[platform.id] || 1;
            const currentCountForPlatform = socialAccounts.filter((account) => account.social_account.platform === platform.id).length;
            return currentCountForPlatform >= maxForPlatform;
        })
    }, [socialAccounts, maxSocialAccountsConfig]);

    return (
        <React.Fragment>
            <div className="card card-style p-4 mb-3">
                <div className="row mb-0">
                    <div className="col-xl-12">
                        <BasicProfile />
                    </div>
                </div>
            </div>
            <div className="p-3 d-flex align-items-center justify-content-between">
                <h6 className="m-0">Account(s)</h6>
                <div className="d-flex align-items-center justify-content-end gap-2">
                    {
                        ((socialAccounts ?? []).length > 0 && !allPlatformsAdded) &&
                        <button className="btn rounded-sm btn-primary" onClick={() => dispatch(toggleAddSocialAccountModal({active: true}))}>+ Add</button>
                    }
                </div>
            </div>

            {
                (socialAccounts ?? []).map((socialAccount, i) => {
                    return (
                        <SocialAccountCard socialAccount={socialAccount} key={i} />
                    )
                })
            }

            {
                (socialAccounts ?? []).length === 0 &&
                <div className="card card-style">
                    <div className="card-body rounded-4 d-flex h-100 flex-column align-items-center justify-content-center">
                        <h4 className="color pop w-100 text-center">
                            Connect with Brands and Unlock Your Potential
                        </h4>
                        <p className="w-100 text-center">
                            Add a Social Account to Access Exclusive Insights and Collaboration Opportunities
                        </p>
                        <button onClick={() => dispatch(toggleAddSocialAccountModal({active: true}))} className='btn btn-flex btn-sm rounded-sm btn-primary fw-bold'>
                            Add Social Account
                        </button>
                    </div>
                </div>
            }

            <div className="divider my-3"></div>

            <div className="px-3 mb-3">
                <span>To delete your account data permanently, <u  className="cursor-pointer" onClick={() => setAccountDeletionModalActive(true)}>Request Deletion</u></span>
            </div>
            <AccountDeletionModal isActive={isAccountDeletionModalActive} onClose={() => setAccountDeletionModalActive(false)} />
        </React.Fragment>
    )
}

export default Profile